

















import Component, { mixins } from 'vue-class-component'
import { AgingFilterFormsMixin } from './AgingFilterFormsMixin'
import Checkbox from '../../../../../../components/inputsV2/Checkbox.vue'

@Component({
  components: { Checkbox }
})
export default class ZeroBalanceFilterForm extends mixins(AgingFilterFormsMixin) {
  localOptions: any = [
    {
      value: true,
      label: 'Hide zero balances'
    }
  ]
}
